import { render, staticRenderFns } from "./DynamicFormTabsCard.vue?vue&type=template&id=30b6329e&"
import script from "./DynamicFormTabsCard.vue?vue&type=script&lang=js&"
export * from "./DynamicFormTabsCard.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormTabsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports